.alert {
  align-items: flex-start;
}

.info-icon {
  :global(.anticon) {
    padding: 3px 0 0;
  }

  &.warning-type {
    :global(.anticon) {
      color: var(--warning-color);
    }
  }

  &.info-type {
    :global(.anticon) {
      color: var(--daybreak-blue-5-color);
    }
  }
}

.neutral-palette {
  padding: 0;
  border: none;
  background: transparent;
  font-size: var(--sm-font-size);
  color: var(--neutral-7-color);
  line-height: 20px;

  :global(.anticon) {
    color: var(--neutral-7-color);
    font-size: var(--md-font-size);
  }
}

.success-palette {
  background-color: var(--resolved-bg);
  border-color: var(--resolved-border-color);
  color: var(--neutral-8-color);

  :global(.anticon) {
    color: var(--resolved-color);
    vertical-align: middle;
  }
}

.info-palette {
  background-color: var(--daybreak-blue-1-color);
  border-color: var(--daybreak-blue-3-color);

  :global(.anticon) {
    color: var(--daybreak-blue-5-color);
    vertical-align: middle;
  }
}
